import { CubeQuery } from '../../../types/cube';

export const UserCountriesKeys = {
  all: ['user-countries'] as const,
  list: (query: CubeQuery) => [...UserCountriesKeys.all, 'list', query] as const,
};
